import React, { useState } from 'react';
import { Button, CircularProgress, Snackbar, Alert } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { generateAiDraft } from '../../../services/tutorTopicContentService';

interface Props {
  courseId: number;
  nodeId: number;
  onDraftReceived: (draftContent: string) => void;
}

export default function AiGenerateButton({ courseId, nodeId, onDraftReceived }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleGenerate = async () => {
    setLoading(true);
    try {
      const result = await generateAiDraft(courseId, nodeId);
      onDraftReceived(result.draftContent);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        onClick={handleGenerate}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={14} /> : <AutoAwesomeIcon fontSize="small" />}
      >
        {loading ? 'Generating…' : 'Generate with AI'}
      </Button>
      <Snackbar
        open={error}
        autoHideDuration={4000}
        onClose={() => setError(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="error" onClose={() => setError(false)}>
          AI generation failed — please try again.
        </Alert>
      </Snackbar>
    </>
  );
}
